export default {
    path: '/',
    name: 'about',
    component: require('./About').default
}